import { UUID } from '@cmg/common';

import { useMatchingCmgEntityKeys } from '../useMatchingCmgEntityKeys';
import { useIsUserSettlementAgent_OfferingSettlementAgentQuery } from './graphql';

export function useIsUserSettlementAgent({ offeringId }: { offeringId?: UUID }) {
  const { data, loading, error } = useIsUserSettlementAgent_OfferingSettlementAgentQuery({
    variables: { offeringId: offeringId! },
    skip: !offeringId,
  });
  const matchingCmgEntityKeys = useMatchingCmgEntityKeys();

  if (loading) {
    return {
      loading,
      error: undefined,
      isSettlementAgent: undefined,
    };
  }

  if (error) {
    return {
      loading: false,
      error,
      isSettlementAgent: undefined,
    };
  }

  return {
    loading: false,
    error: undefined,
    isSettlementAgent: matchingCmgEntityKeys.includes(
      data?.publishedOfferings?.items?.[0]?.syndicate?.managerResponsibilities.settlementAgent ?? ''
    ),
  };
}
